<template>
    <MainHeader app="clp" />

    <div class="board-tabs-holder settings-tabs">
        <ul class="board-tabs">
            <li
                @click="changeTab('facilities')"
                :class="currentTab == 'facilities' ? 'current' : ''"
            >
                Anläggningar
            </li>
            <li
                @click="changeTab('categories')"
                :class="currentTab == 'categories' ? 'current' : ''"
            >
                Kategorier
            </li>
            <li
                @click="changeTab('types')"
                :class="currentTab == 'types' ? 'current' : ''"
            >
                Typer & Actions
            </li>
            <li
                @click="changeTab('informations')"
                :class="currentTab == 'informations' ? 'current' : ''"
            >
                Hjälptexter
            </li>
            <li
                @click="changeTab('login-informations')"
                :class="currentTab == 'login-informations' ? 'current' : ''"
            >
                Inloggningsinformation
            </li>
            <li
                @click="changeTab('notifications')"
                :class="currentTab == 'notifications' ? 'current' : ''"
            >
                Utskick
            </li>
            <li
                @click="changeTab('statistics')"
                :class="currentTab == 'statistics' ? 'current' : ''"
            >
                Statistik
            </li>
            <li
                @click="changeTab('translations')"
                :class="currentTab == 'translations' ? 'current' : ''"
            >
                Översättningar
            </li>
        </ul>
    </div>

    <main class="settings-holders">
        <div class="setting-tab" v-show="currentTab === 'facilities'">
            <!-- Boards -->
            <div class="holder-settings">
                <h2>Anläggningar</h2>
                <p>Samtalsförsök per anläggning och dag<br /><br /></p>
                <div class="table-list">
                    <div class="table-row">
                        <div style="width: 400px"></div>
                        <div>
                            <div style="width: 190px; margin-right: 20px">
                                <strong>Mån-Fre</strong>
                            </div>
                            <div style="width: 190px">
                                <strong>Lör-Sön</strong>
                            </div>
                        </div>
                    </div>

                    <div v-for="(center, index) in centers" class="table-row">
                        <div style="width: 400px">{{ center.name }}</div>
                        <div>
                            <input
                                type="text"
                                class="input-setting"
                                v-model="center.number_of_todos"
                                style="width: 190px; margin-right: 20px"
                            />

                            <input
                                type="text"
                                class="input-setting"
                                v-model="center.number_of_todos_for_weekend"
                                style="width: 190px"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Categories -->
        <div class="setting-tab" v-show="currentTab === 'categories'">
            <div class="holder-settings">
                <h2>Kategorier</h2>
                <p>
                    Ange vilka huvudkategori och kategorier som ska finnas.<br /><br />
                </p>

                <div
                    class="category"
                    v-for="(mainCategory, mainIndex) in mainCategories"
                >
                    <div class="category-header">
                        <h3>
                            <input
                                type="text"
                                class="input-header"
                                v-model="mainCategory.name"
                            />
                        </h3>
                        <div class="input-header-buttons">
                            <i
                                class="material-icons pointer"
                                @click="mainCategories.splice(mainIndex, 1)"
                                >delete</i
                            >
                            <i
                                :class="
                                    mainCategory?.open
                                        ? 'board-settings-open'
                                        : ''
                                "
                                class="board-settings material-icons pointer"
                                @click="mainCategory.open = !mainCategory?.open"
                                >expand_more</i
                            >
                        </div>
                    </div>
                    <div class="list-group" v-show="mainCategory?.open">
                        <draggable
                            v-model="mainCategory.categories"
                            item-key="id"
                            handle=".handle"
                        >
                            <template #item="{ element, index }">
                                <div
                                    class="list-item"
                                    :class="
                                        element?.open ? 'list-item-open' : ''
                                    "
                                >
                                    <div class="list-item-header">
                                        <input
                                            class="input-setting"
                                            type="text"
                                            v-model="element.name"
                                        />
                                        <div class="list-item-header-actions">
                                            <div class="handle">
                                                <i
                                                    class="material-icons pointer board-info-button"
                                                    >drag_indicator</i
                                                >
                                            </div>

                                            <i
                                                class="material-icons pointer board-info-button"
                                                @click="
                                                    mainCategories[
                                                        mainIndex
                                                    ].categories.splice(
                                                        index,
                                                        1
                                                    )
                                                "
                                                >delete</i
                                            >

                                            <i
                                                :class="
                                                    element?.open
                                                        ? 'board-settings-open'
                                                        : ''
                                                "
                                                class="material-icons pointer board-info-button board-settings"
                                                @click="
                                                    element.open = !element.open
                                                "
                                                >expand_more</i
                                            >
                                        </div>
                                    </div>
                                    <div
                                        class="list-item-content"
                                        v-show="element?.open"
                                    >
                                        <label>Informations Text</label>
                                        <div
                                            class="QuillEditorHolder text-content"
                                        >
                                            <QuillEditor
                                                contentType="html"
                                                v-model:content="element.info"
                                                theme="snow"
                                            />
                                        </div>
                                        <div>
                                            <label>Tillgängliga actions</label>
                                            <div
                                                class="action-category"
                                                v-for="actionCategory in newActions"
                                            >
                                                <strong>{{
                                                    actionCategory.name
                                                }}</strong>
                                                <div class="actions-holder">
                                                    <label
                                                        class="label-checkbox"
                                                        v-for="(
                                                            actionItem, key
                                                        ) in actionCategory.actions"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            :value="
                                                                actionCategory.id +
                                                                '|' +
                                                                actionItem.id
                                                            "
                                                            v-model="
                                                                element.actions
                                                            "
                                                        />
                                                        <div
                                                            class="checkbox"
                                                        ></div>
                                                        {{ actionItem.name }}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </draggable>
                        <div
                            class="buttons button-holder-right"
                            style="margin-top: 10px"
                        >
                            <button
                                class="button button-small"
                                @click="
                                    mainCategory.categories.push({
                                        name: '',
                                        info: '',
                                        types: [],
                                        id: createUniqeId(),
                                        open: true,
                                        actions: [],
                                    })
                                "
                            >
                                Lägg till kategori
                            </button>
                        </div>
                    </div>
                </div>
                <button
                    style="margin-top: 16px"
                    class="button button-small"
                    @click="
                        mainCategories.push({
                            name: 'Ange namn',
                            categories: [],
                            open: true,
                            id: createUniqeId(),
                        })
                    "
                >
                    Lägg till huvudkategori
                </button>
            </div>
        </div>
        <!-- End of boards -->

        <!-- Types -->
        <div class="setting-tab" v-show="currentTab === 'types'">
            <div class="holder-settings">
                <h2>Typer</h2>
                <p>Ange vilka typer som ska finnas.<br /><br /></p>
                <div class="table-list">
                    <div v-for="(item, index) in types" class="table-row">
                        <div>
                            <input
                                type="text"
                                class="input-setting"
                                v-model="item.name"
                                style="width: 400px"
                            />
                        </div>
                        <div class="table-margin">
                            <i class="material-icons arrow">east</i>
                        </div>
                        <div>
                            <select v-model="item.category">
                                <option value=""></option>
                                <optgroup
                                    v-for="board in mainCategories"
                                    :label="board.name"
                                >
                                    <option
                                        :value="asd.id"
                                        v-for="asd in board.categories"
                                    >
                                        {{ asd.name }}
                                    </option>
                                </optgroup>
                                <optgroup label="Övrigt">
                                    <option value="exit">Exit</option>
                                </optgroup>
                            </select>
                        </div>
                        <div class="table-margin-left">
                            <i
                                class="material-icons pointer"
                                @click="types.splice(index, 1)"
                                >delete</i
                            >
                        </div>
                        <div>
                            <textarea
                                class="textarea"
                                v-model="item.info"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <button
                    class="button button-small"
                    @click="types.push({ name: '', category: false })"
                >
                    Lägg till typ
                </button>
            </div>

            <div class="holder-settings">
                <h2>Actions</h2>
                <p>Actions som visas som utfall<br /><br /></p>
                <div class="category" v-for="(item, index) in newActions">
                    <div class="category-header">
                        <h3>
                            <input
                                type="text"
                                class="input-header"
                                v-model="item.name"
                            />
                        </h3>
                        <div class="input-header-buttons">
                            <i
                                class="material-icons pointer"
                                @click="newActions.splice(index, 1)"
                                >delete</i
                            >
                            <i
                                :class="item?.open ? 'board-settings-open' : ''"
                                class="board-settings material-icons pointer"
                                @click="item.open = !item?.open"
                                >expand_more</i
                            >
                        </div>
                    </div>
                    <div class="list-group">
                        <!-- Actions -->

                        <div class="table-list">
                            <div
                                v-for="(
                                    actionItem, actionIndex
                                ) in item.actions"
                                class="table-row"
                            >
                                <div>
                                    <input
                                        type="text"
                                        class="input-setting"
                                        v-model="actionItem.name"
                                        style="width: 400px"
                                    />
                                </div>
                                <div class="table-margin">
                                    <i class="material-icons arrow">east</i>
                                </div>
                                <div>
                                    <select v-model="actionItem.type">
                                        <option value=""></option>
                                        <option
                                            :value="typeItem.name"
                                            v-for="typeItem in types"
                                        >
                                            {{ typeItem.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="table-margin-left">
                                    <input
                                        type="number"
                                        v-model="actionItem.dueDate"
                                        class="input-setting input-setting-due-date"
                                    />
                                </div>
                                <div class="table-margin-left">
                                    <i
                                        class="material-icons pointer"
                                        @click="
                                            newActions[index].actions.splice(
                                                actionIndex,
                                                1
                                            )
                                        "
                                        >delete</i
                                    >
                                </div>
                            </div>
                        </div>

                        <!-- End of actions-->
                        <!-- Add new actions-->
                        <button
                            class="button button-small"
                            @click="
                                item.actions.push({
                                    id: createUniqeId(),
                                    name: '',
                                    category: '',
                                })
                            "
                        >
                            Lägg till action
                        </button>
                    </div>
                </div>

                <button
                    class="button button-small"
                    @click="
                        newActions.push({
                            id: createUniqeId(),
                            name: '',
                            actions: [],
                        })
                    "
                >
                    Lägg till action kategori
                </button>
            </div>

            <div class="holder-settings">
                <h2>Övriga actions</h2>
                <p>Actions som används i systemet<br /><br /></p>
                <div class="table-row">
                    <div>Nytt lead via API</div>
                    <div class="table-margin">
                        <i class="material-icons arrow">east</i>
                    </div>
                    <div>
                        <select v-model="settings.newLead.type">
                            <option value=""></option>
                            <option
                                :value="typeItem.name"
                                v-for="typeItem in types"
                            >
                                {{ typeItem.name }}
                            </option>
                        </select>
                    </div>
                    <div class="table-margin-left">
                        <input
                            type="number"
                            v-model="settings.newLead.dueDate"
                            class="input-setting input-setting-due-date"
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- End of types-->

        <!-- Information texts -->
        <div class="setting-tab" v-show="currentTab === 'informations'">
            <div class="holder-settings">
                <h2>Informationstexter på personkortet</h2>
                <p>Informationstexter som visas på personkortet<br /><br /></p>
                <label>Persondata</label>
                <textarea
                    v-model="personCardInfoTexts.personData"
                    class="textarea"
                ></textarea>

                <br />
                <label>Besökshisotrik</label>
                <textarea
                    v-model="personCardInfoTexts.visitHistory"
                    class="textarea"
                ></textarea>

                <br />
                <label>Senaste köp</label>
                <textarea
                    v-model="personCardInfoTexts.lastPurchase"
                    class="textarea"
                ></textarea>

                <br />
                <label>Sälj medlemskap</label>
                <textarea
                    v-model="personCardInfoTexts.sellMembership"
                    class="textarea"
                ></textarea>
            </div>
        </div>
        <!-- End of information texts -->

        <!-- Information texts -->
        <div class="setting-tab" v-show="currentTab === 'login-informations'">
            <div class="holder-settings">
                <h2>Inloggningsinformation</h2>
                <p>Information som ska visas vid inloggning<br /><br /></p>
                <label>Text</label>
                <div class="QuillEditorHolder text-content">
                    <QuillEditor
                        content-type="html"
                        v-model:content="loginInformation"
                        theme="snow"
                    />
                </div>
            </div>
        </div>
        <!-- End of information texts -->

        <!-- Notifications -->
        <div class="setting-tab" v-show="currentTab === 'notifications'">
            <div class="holder-settings">
                <h2>SMS Inställningar</h2>
                <label>Antal dagar mellan SMS utskick</label>
                <select v-model="daysBetweenSMS">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                </select>
                <br />
                <br />

                <h2>SMS Meddelanden</h2>
                <p>Lägg till texter för SMS utskick<br /><br /></p>

                <div v-for="(sms, index) in allSMSTexts">
                    <div class="sms-item">
                        <label>Rubrik</label>
                        <div
                            class="sms-delete-button"
                            @click="allSMSTexts.splice(index, 1)"
                        >
                            <i
                                class="material-icons pointer"
                                @click="mainCategories.splice(mainIndex, 1)"
                                >delete</i
                            >
                        </div>
                    </div>
                    <input
                        type="text"
                        class="input-setting"
                        v-model="sms.title"
                    /><br />
                    <br />
                    <label>Text</label><br />
                    <textarea class="textarea" v-model="sms.text"></textarea>
                    <div class="letter-count">
                        Antal tecken: {{ sms.text.length }}
                    </div>
                    <br />
                </div>

                <button
                    class="button"
                    @click="
                        allSMSTexts.push({
                            id: createUniqeId(),
                            title: '',
                            text: '',
                        })
                    "
                >
                    Lägg till SMS Meddelande
                </button>

                <br /><br /><br /><br />
                <label>Action där sms-utskick ska visas</label>
                <select v-model="missedCallActionId">
                    <optgroup
                        v-for="actionCategory in newActions"
                        :label="actionCategory.name"
                    >
                        <option
                            :value="actionItem.id"
                            v-for="actionItem in actionCategory.actions"
                        >
                            {{ actionItem.name }}
                        </option>
                    </optgroup>
                </select>
            </div>
        </div>
        <!-- End of information texts -->

        <!-- Statistics -->
        <div class="setting-tab" v-show="currentTab === 'statistics'">
            <div class="holder-settings">
                <h2>Statistik</h2>
                <p>Inställningar för statistik<br /><br /></p>
                <label>Konverteringskategori</label>
                <select v-model="statistics.conversionsCategory">
                    <option value="false">Välj kategori</option>
                    <option
                        v-for="actionCategory in newActions"
                        :value="actionCategory.id"
                    >
                        {{ actionCategory.name }}
                    </option>
                </select>

                <br /><br />

                <label>Progressionkategori</label>
                <select v-model="statistics.progressionCategory">
                    <option value="false">Välj kategori</option>
                    <option
                        v-for="actionCategory in newActions"
                        :value="actionCategory.id"
                    >
                        {{ actionCategory.name }}
                    </option>
                </select>

                <br /><br />

                <label>Tackat nej</label>
                <select v-model="statistics.noThanksCategory">
                    <option value="false">Välj kategori</option>
                    <option
                        v-for="actionCategory in newActions"
                        :value="actionCategory.id"
                    >
                        {{ actionCategory.name }}
                    </option>
                </select>

                <br /><br />

                <label>Vill avvakta</label>
                <select v-model="statistics.willWaitCategory">
                    <option value="false">Välj kategori</option>
                    <option
                        v-for="actionCategory in newActions"
                        :value="actionCategory.id"
                    >
                        {{ actionCategory.name }}
                    </option>
                </select>

                <br /><br />

                <label>Missat samtal</label>
                <select v-model="statistics.missedCallCategory">
                    <option value="false">Välj kategori</option>
                    <option
                        v-for="actionCategory in newActions"
                        :value="actionCategory.id"
                    >
                        {{ actionCategory.name }}
                    </option>
                </select>
            </div>
        </div>
        <!-- End of information texts -->

        <!-- Translations -->
        <div class="setting-tab" v-show="currentTab === 'translations'">
            <div class="holder-settings">
                <h2>Översättningar</h2>
                <p>Översättningar för olika delar av systemet</p>
                <select v-model="currentTranslation">
                    <option value="false">Välj språk</option>
                    <option value="no">Norska</option>
                </select>
                <div v-show="currentTranslation !== 'false'" class="w-full">
                    <h2>{{ translations[currentTranslation]?.name }}</h2>

                    <h3>Kategorier</h3>

                    <div v-for="(mainCategory, mainIndex) in mainCategories">
                        <div class="translation-item">
                            <div class="translation-orignal-text">
                                {{ mainCategory.name }}
                            </div>
                            <div class="translation-translated-text">
                                <input
                                    type="text"
                                    @change="
                                        updateTranslation(
                                            'mainCategory|' + mainCategory.id,
                                            $event
                                        )
                                    "
                                    :value="
                                        getTranslation(
                                            'mainCategory|' + mainCategory.id
                                        )
                                    "
                                />
                            </div>
                        </div>

                        <div
                            class="w-full"
                            v-for="category in mainCategory.categories"
                        >
                            <div class="translation-item">
                                <div class="translation-orignal-text">
                                    {{ category.name }}
                                </div>
                                <div class="translation-translated-text">
                                    <input
                                        type="text"
                                        @change="
                                            updateTranslation(
                                                'category|' + category.id,
                                                $event
                                            )
                                        "
                                        :value="
                                            getTranslation(
                                                'category|' + category.id
                                            )
                                        "
                                    />
                                </div>
                            </div>

                            <div class="translation-item">
                                <div
                                    class="translation-orignal-text text-content"
                                    v-html="category.info"
                                ></div>
                                <div class="translation-translated-text">
                                    <div
                                        class="translation-editor-holder text-content"
                                    >
                                        <QuillEditor
                                            content-type="html"
                                            @blur="
                                                (editor) => {
                                                    updateTranslationTextarea(
                                                        'category|info|' +
                                                            category.id,
                                                        editor
                                                    );
                                                }
                                            "
                                            :content="
                                                getTranslationTextarea(
                                                    'category|info|' +
                                                        category.id
                                                )
                                            "
                                            theme="snow"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3>Typer</h3>
                    <div v-for="(item, index) in types">
                        <div class="translation-item">
                            <div class="translation-orignal-text">
                                {{ item.name }}
                            </div>
                            <div class="translation-translated-text">
                                <input
                                    type="text"
                                    @change="
                                        updateTranslation(
                                            'type|' + item.name,
                                            $event
                                        )
                                    "
                                    :value="getTranslation('type|' + item.name)"
                                />
                            </div>
                        </div>

                        <div class="translation-item">
                            <div class="translation-orignal-text">
                                {{ item.info }}
                            </div>
                            <div class="translation-translated-text">
                                <textarea
                                    class="textarea"
                                    @change="
                                        updateTranslation(
                                            'type|info|' + item.name,
                                            $event
                                        )
                                    "
                                    :value="
                                        getTranslation('type|info|' + item.name)
                                    "
                                />
                            </div>
                        </div>
                    </div>

                    <h3>Actions</h3>

                    <div v-for="(item, index) in newActions">
                        <div class="translation-item">
                            <div class="translation-orignal-text">
                                {{ item.name }}
                            </div>
                            <div class="translation-translated-text">
                                <input
                                    type="text"
                                    @change="
                                        updateTranslation(
                                            'actionCategory|' + item.id,
                                            $event
                                        )
                                    "
                                    :value="
                                        getTranslation(
                                            'actionCategory|' + item.id
                                        )
                                    "
                                />
                            </div>
                        </div>

                        <div class="w-full" v-for="actionItem in item.actions">
                            <div class="translation-item">
                                <div class="translation-orignal-text">
                                    {{ actionItem.name }}
                                </div>
                                <div class="translation-translated-text">
                                    <input
                                        type="text"
                                        @change="
                                            updateTranslation(
                                                'action|' + actionItem.id,
                                                $event
                                            )
                                        "
                                        :value="
                                            getTranslation(
                                                'action|' + actionItem.id
                                            )
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <h2>Informationstext vid inloggning</h2>
                    <div class="translation-item">
                        <div
                            class="translation-orignal-text text-content"
                            v-html="loginInformation"
                        ></div>
                        <div class="translation-translated-text">
                            <div class="translation-editor-holder text-content">
                                <QuillEditor
                                    content-type="html"
                                    @blur="
                                        (editor) => {
                                            updateTranslationTextarea(
                                                'login_informationtext',
                                                editor
                                            );
                                        }
                                    "
                                    :content="
                                        getTranslationTextarea(
                                            'login_informationtext'
                                        )
                                    "
                                    theme="snow"
                                />
                            </div>
                        </div>
                    </div>

                    <h2>Informationstexter på personkortet</h2>
                    <div class="translation-item">
                        <div class="translation-orignal-text">
                            <strong>Persondata</strong><br />
                            {{ personCardInfoTexts.personData }}
                        </div>
                        <div class="translation-translated-text">
                            <textarea
                                class="textarea"
                                @change="
                                    updateTranslation(
                                        'personCardInfoTexts|personData',
                                        $event
                                    )
                                "
                                :value="
                                    getTranslation(
                                        'personCardInfoTexts|personData'
                                    )
                                "
                            ></textarea>
                        </div>
                    </div>

                    <div class="translation-item">
                        <div class="translation-orignal-text">
                            <strong>Besökshisotrik</strong><br />
                            {{ personCardInfoTexts.visitHistory }}
                        </div>
                        <div class="translation-translated-text">
                            <textarea
                                class="textarea"
                                @change="
                                    updateTranslation(
                                        'personCardInfoTexts|visitHistory',
                                        $event
                                    )
                                "
                                :value="
                                    getTranslation(
                                        'personCardInfoTexts|visitHistory'
                                    )
                                "
                            ></textarea>
                        </div>
                    </div>

                    <div class="translation-item">
                        <div class="translation-orignal-text">
                            <strong>Senaste köp</strong><br />
                            {{ personCardInfoTexts.lastPurchase }}
                        </div>
                        <div class="translation-translated-text">
                            <textarea
                                class="textarea"
                                @change="
                                    updateTranslation(
                                        'personCardInfoTexts|lastPurchase',
                                        $event
                                    )
                                "
                                :value="
                                    getTranslation(
                                        'personCardInfoTexts|lastPurchase'
                                    )
                                "
                            ></textarea>
                        </div>
                    </div>

                    <div class="translation-item">
                        <div class="translation-orignal-text">
                            <strong>Sälj medlemskap</strong><br />
                            {{ personCardInfoTexts.sellMembership }}
                        </div>
                        <div class="translation-translated-text">
                            <textarea
                                class="textarea"
                                @change="
                                    updateTranslation(
                                        'personCardInfoTexts|sellMembership',
                                        $event
                                    )
                                "
                                :value="
                                    getTranslation(
                                        'personCardInfoTexts|sellMembership'
                                    )
                                "
                            ></textarea>
                        </div>
                    </div>

                    <h2>Utskick</h2>

                    <div class="translation-item" v-for="sms in allSMSTexts">
                        <div class="translation-orignal-text">
                            <strong>{{ sms.title }}</strong
                            ><br />
                            {{ sms.text }}<br />
                        </div>
                        <div class="translation-translated-text">
                            <input
                                type="text"
                                @change="
                                    updateTranslation(
                                        'allSMSTexts|title|' + sms.id,
                                        $event
                                    )
                                "
                                :value="
                                    getTranslation(
                                        'allSMSTexts|title|' + sms.id
                                    )
                                "
                            />

                            <br />

                            <textarea
                                class="textarea"
                                @change="
                                    updateTranslation(
                                        'allSMSTexts|text|' + sms.id,
                                        $event
                                    )
                                "
                                :value="
                                    getTranslation('allSMSTexts|text|' + sms.id)
                                "
                            ></textarea>

                            <div class="letter-count">
                                Antal tecken:
                                {{
                                    getTranslation("allSMSTexts|text|" + sms.id)
                                        ?.length
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    <button class="settings-save button button-small" @click="save()">
        Spara
    </button>

    <div v-if="loading" class="loading">
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import axios from "axios";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { v4 as uuid } from "uuid";
import { mapStores } from "pinia";
import MainHeader from "../MainHeader.vue";
import { useAuthStore } from "../../stores/auth.js";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

export default {
    computed: {
        ...mapStores(useAuthStore),
    },
    components: {
        draggable,
        QuillEditor,
    },
    data() {
        return {
            actions: [],
            types: [],
            selectedTypes: [],
            mainCategories: [],
            centers: [],
            loading: true,
            newActions: [],
            settings: {
                newLead: {
                    id: "",
                    type: "",
                    dueDate: 0,
                },
            },
            personCardInfoTexts: {
                personData: "",
                visitHistory: "",
                lastPurchase: "",
                sellMembership: "",
            },
            currentTab: "facilities",
            currentTranslation: "false",
            translations: {
                no: {
                    name: "Norska",
                    translations: {},
                },
            },
            statistics: {
                conversionsCategory: "false",
                progressionCategory: "false",
            },
            loginInformation: "",
            SMSText: "",
            missedCallActionId: "",
            allSMSTexts: [],
            daysBetweenSMS: 1,
        };
    },
    mounted() {
        let self = this;
        axios
            .post(
                self.authStore.api + "/clp/settings/get",
                {
                    key: "CLPSettings",
                },
                {
                    headers: {
                        Authorization: "Bearer " + self.authStore.token,
                    },
                }
            )
            .then((response) => {
                self.mainCategories =
                    response.data.settings.CLPBoards !== undefined
                        ? response.data.settings.CLPBoards
                        : [];

                self.types = response.data.settings.CLPTypes;

                self.newActions =
                    response.data.settings.CLPNewActions !== undefined
                        ? response.data.settings.CLPNewActions
                        : [];
                self.actions =
                    response.data.settings.CLPActions !== undefined
                        ? response.data.settings.CLPActions
                        : [];
                self.centers = response.data.centers;

                if (
                    response.data.settings?.CLPSettings?.newLead !== undefined
                ) {
                    self.settings.newLead =
                        response.data.settings.CLPSettings.newLead;
                } else {
                    self.settings.newLead = {
                        id: self.createUniqeId(),
                        type: "",
                        dueDate: 0,
                    };
                }

                self.personCardInfoTexts =
                    response.data.settings.CLPPersonCardInfoTexts !== undefined
                        ? response.data.settings.CLPPersonCardInfoTexts
                        : {
                              personData: "",
                              visitHistory: "",
                              lastPurchase: "",
                              sellMembership: "",
                          };

                // Load translations
                if (response.data.settings.CLPTranslations !== undefined) {
                    for (const [key, value] of Object.entries(
                        response.data.settings.CLPTranslations
                    )) {
                        if (!Array.isArray(value.translations)) {
                            self.translations[key].translations =
                                value.translations;
                        }
                    }
                }

                if (response.data.settings.CLPStatistics !== undefined) {
                    self.statistics = response.data.settings.CLPStatistics;
                }

                if (response.data.settings.CLPLoginInformation !== undefined) {
                    self.loginInformation =
                        response.data.settings.CLPLoginInformation;
                }

                if (response.data.settings.CLPSMSText !== undefined) {
                    self.SMSText = response.data.settings.CLPSMSText;
                }

                if (response.data.settings.CLPMissedCallAcionId !== undefined) {
                    self.missedCallActionId =
                        response.data.settings.CLPMissedCallAcionId;
                }

                if (response.data.settings.CLPSMSTexts !== undefined) {
                    self.allSMSTexts = response.data.settings.CLPSMSTexts;
                }

                if (response.data.settings.CLPDaysBetweenSMS !== undefined) {
                    self.daysBetweenSMS =
                        response.data.settings.CLPDaysBetweenSMS;
                }

                self.loading = false;
            })
            .catch((error) => {
                this.loading = false;
                console.log(error);
            });
    },
    methods: {
        getTranslation(id) {
            if (this.currentTranslation === "false") {
                return;
            }

            if (
                this.translations[this.currentTranslation]?.translations[id] ===
                undefined
            ) {
                this.translations[this.currentTranslation].translations[id] =
                    "";
            }

            return this.translations[this.currentTranslation].translations[id];
        },

        getTranslationTextarea(id) {
            if (this.currentTranslation === "false") {
                return;
            }

            if (
                this.translations[this.currentTranslation]?.translations[id] ===
                undefined
            ) {
                this.translations[this.currentTranslation].translations[id] =
                    "";
            }

            return this.translations[this.currentTranslation].translations[id];
        },

        updateTranslation(id, event) {
            this.translations[this.currentTranslation].translations[id] =
                event.target.value;
        },
        updateTranslationTextarea(id, editor) {
            this.translations[this.currentTranslation].translations[id] =
                editor.value.__quill.root.innerHTML;
        },
        changeTab(tab) {
            this.currentTab = tab;
            window.scrollTo(0, 0);
        },
        createUniqeId() {
            return uuid();
        },
        removeItem(mainIndex, index) {
            this.mainCategories[mainIndex].categories.splice(index, 1);
        },
        save() {
            this.loading = true;
            let self = this;
            let CLPSettings = {
                CLPBoards: this.mainCategories,
                CLPActions: this.actions,
                CLPTypes: this.types,
                CLPCenters: this.centers,
                CLPNewActions: this.newActions,
                CLPSettings: this.settings,
                CLPPersonCardInfoTexts: this.personCardInfoTexts,
                CLPTranslations: this.translations,
                CLPStatistics: this.statistics,
                CLPLoginInformation: this.loginInformation,
                CLPMissedCallAcionId: this.missedCallActionId,
                CLPSMSTexts: this.allSMSTexts,
                CLPDaysBetweenSMS: this.daysBetweenSMS,
            };

            axios
                .post(
                    self.authStore.api + "/clp/settings/update",
                    {
                        CLPSettings: CLPSettings,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    self.loading = false;
                    toast("Inställningarna sparade!", {
                        type: "success",
                        position: "bottom-right",
                        autoClose: 1000,
                        dangerouslyHTMLString: true,
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>

<style>
.settings-holders {
    margin-top: 200px;
}

.holder-settings {
    display: flex;
    width: calc(100% - 20px);
    max-width: 1200px;
    margin: 0 auto;
    flex-direction: column;
    margin-bottom: 60px;
    margin-top: 40px;
    justify-content: flex-start;
    align-items: flex-start;

    h2 {
        margin-bottom: 10px;
    }
}

.settings-header {
    display: flex;
    width: calc(100% - 20px);
    max-width: 1200px;
    margin: 0 auto;
    flex-direction: column;
}

table {
    width: 900px;
    margin-bottom: 32px;

    td {
        vertical-align: middle;
    }

    > td {
        padding-right: 20px;
    }

    .arrow {
        margin: 0 16px;
    }
}

.table-row {
    padding: 0 30px;
    transition: all 0.1s ease;
    margin-left: -30px;

    flex-direction: column;
    margin-bottom: 30px;

    > div {
        margin-bottom: 6px;
    }

    &:hover {
        background-color: #f6f6f6;
        transition: all 0.1s ease;
    }

    @media (min-width: 900px) {
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 20px;

        > div {
            margin-bottom: 0;
        }
    }
}

td .input-setting {
    width: 300px;
}

.types {
    position: fixed;
    right: 0;
    top: 0;
    width: 400px;
    background-color: cadetblue;
    height: 100%;
}

.category {
    max-width: 1200px;
    width: 100%;
    margin-bottom: 30px;
}

.handle {
    cursor: move;
}

.list-group {
    margin-bottom: 30px;
}

.list-item {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    flex-direction: column;
    margin-bottom: 10px;
}

.list-item-open {
    margin-bottom: 40px;
}

.list-item-header {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 8px;
    border-radius: 6px 6px 0 0;
    background-color: #ccd5e0;

    input {
        font-family: "hansen-grotesque-bold";
        background-color: transparent;
        font-size: 18px;
        font-weight: 700;
        border: 0;
        &:focus {
            border: 0;
            outline: 0;
        }
    }
}

.list-item-header-actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    padding-right: 20px;
}

.list-item-content {
    padding: 40px;
    width: 100%;
    border: 1px solid #ccd5e0;
    border-radius: 0 0 6px 6px;

    > label {
        margin-bottom: 10px;
        display: block;
    }
}

.more-settings {
    width: 100%;
    background-color: papayawhip;
    margin-left: 50px;
    padding: 20px;
    display: flex;
    flex-direction: column;
}

.action-list {
    width: 100%;
}

.input[type="text"].input-setting {
    width: 100%;
    max-width: 630px;
    height: 50px;
    border: 1px solid rgba(161, 177, 200, 0.5);
    background-color: #fff;
    margin-bottom: 0;
    border-radius: 6px;
    padding: 0 20px;
    font-size: 16px;
    font-weight: 300;
}

input[type="number"].input-setting-due-date {
    width: 80px;
}

input[type="text"].input-header {
    background-color: unset;
    border: unset;
    width: unset;
    color: #000;
    margin: 0;
    padding: 0;
    font-family: "hansen-grotesque-bold", sans-serif;
    font-size: 23px;
    font-weight: 700;
    line-height: 33px;

    &:active,
    &:focus {
        outline: none;
        border: 0;
    }
}
.textarea {
    max-width: 100%;
    width: 630px;
    height: 120px;
    margin-bottom: 40px;
    padding: 20px;
    border: 1px solid #ccd5e0;
    background: #fff;
    border-radius: 6px;
    resize: none;
    font-family: "helvetica-regular", sans-serif;
    font-size: 16px;
    font-weight: 300;

    &:focus {
        border: 1px solid rgba(161, 177, 200, 1);
        outline: 0;
    }

    &:active {
        border: 1px solid rgba(161, 177, 200, 1);
        outline: 0;
    }
}

.pointer {
    cursor: pointer;
}

.settings-header {
    height: 100px;
}

.settings-save {
    position: fixed;
    right: 20px;
    bottom: 20px;
}

.category-header {
    background: #a1b1c8;
    display: flex;
    padding: 2px 20px;
    align-items: center;
    justify-content: space-between;
    border-radius: 6px 6px 0 0;
    margin-bottom: 10px;
}

.board-settings {
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 32px;
}

.board-settings-open {
    transform: rotate(180deg);
    transition: all 0.3s ease;
}

.input-header-buttons {
    display: flex;
    align-items: center;
}

.actions-holder {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 20px;
}

.holder-settings {
    select {
        width: 345px;
    }
}

.QuillEditorHolder {
    width: 100%;
    height: 300px;
    margin-bottom: 80px;
}

.action-category {
    margin-top: 10px;

    strong {
        margin-bottom: 6px;
        display: block;
    }
}

.settings-tabs {
    position: fixed;
    width: 100%;
    top: 90px;
    background-color: #f2f2f2;
    z-index: 10;
    padding-top: 6px;
}

.setting-tab {
    padding-bottom: 100px;
}

.translation-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-bottom: 60px;
}

.translation-orignal-text {
    width: calc(50% - 20px);
    display: flex;
    flex-direction: column;
}

.translation-translated-text {
    width: calc(50% - 20px);
    display: flex;
    flex-direction: column;
}

.w-full {
    width: 100%;
}

.translation-editor-holder {
    width: 100%;
    height: 100%;
    margin-bottom: 80px;
}

.sms-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    label {
        margin-bottom: 0;
    }
}

.sms-delete-button {
    margin-left: auto;
}

.letter-count {
    top: -30px;
    position: relative;
    font-size: 13px;
}
</style>
